module.exports = __webpack_public_path__ + "img/0.a6f961fa.png";